module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/free-pay/free-pay.component.scss
// module id = ./src/app/admin/components/free-pay/free-pay.component.scss
// module chunks = main